module.exports = __webpack_public_path__ + "static/media/ArcaniaAndAurisBg-sm.8ae3f2d3.jpg";